/**
 * Automy.Core.Enums.Reporting.Queries.ReportingQueryType
 * Native queries[].type (string token).
 */
export default Object.freeze({
  Rows: 'rows',
  Aggregate: 'aggregate',
});
